import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-central-cliente-pacotes-cliente',
  templateUrl: './central-cliente-pacotes-cliente.component.html',
  styleUrls: ['./central-cliente-pacotes-cliente.component.scss']
})
export class CentralClientePacotesClienteComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  listaPacotes: Orcamento[] = [];
  clientesComPacote: Cliente[] = [];
  clienteSelecionado?: Cliente;


  itensPaginados?: Paginador<Orcamento>;
  numeroPagina: number = 0;
  inputBusca?: string = '';
  ordenacao: string = 'nome,ASC';
  tamanhoPagina: number = 10;

  constructor(private orcamentoService: OrcamentoService,
    public clienteService: ClienteService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.carregarCliente();

  }

  carregarCliente() {
    this.clienteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: Cliente) => {
        this.clienteSelecionado = data;
        this.listarPacotesCliente();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  listarPacotesCliente() {
    this.orcamentoService.listarTodosOsPacotePorEmpresaECliente(this.getEmpresa().id, this.idParametroUrl).subscribe({
      next: (data: Orcamento[]) => {
        this.listaPacotes = data;
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }


  buscar(event: Event) {
    this.inputBusca = (event.target as HTMLInputElement).value;
    //this.listarClientes(0);
  }

  limpar(table: Table) {
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    table.clear()
  }

}
